var FontStyleName = /** @class */ (function () {
    function FontStyleName() {
    }
    FontStyleName.STANDART = 'standart';
    FontStyleName.BOLD = 'bold';
    FontStyleName.ITALIC = 'italic';
    FontStyleName.BOLDITALIC = 'boldItalic';
    return FontStyleName;
}());
export { FontStyleName };
